import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { Check } from 'lucide-react';

const ReflectionJournalElement = ({ config, element, onComplete, onSaveData, isCompleted, progress }) => {
  const saved = progress?.element_progress?.[element.id] || {};
  const [text, setText] = useState(saved.reflection_text || '');
  const wordCount = text.trim() ? text.trim().split(/\s+/).length : 0;
  const minWords = config.min_words || 0;
  const handleSave = () => { onSaveData({ reflection_text: text, word_count: wordCount }); if (!isCompleted && wordCount >= minWords) { onComplete(); toast.success('Reflection saved!'); } else if (wordCount < minWords) { toast.error(`Please write at least ${minWords} words`); } };
  return (
    <div className="space-y-4">
      {config.prompt && <div className="p-4 bg-[#f8fafc] rounded-xl text-slate-700 italic">{config.prompt}</div>}
      <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder={config.placeholder_text || 'Write your reflection here...'} rows={8} className="text-base leading-relaxed" data-testid="reflection-textarea" />
      {config.show_word_count !== false && <div className="flex justify-between text-xs text-slate-500"><span>{wordCount} words</span>{minWords > 0 && <span className={wordCount >= minWords ? 'text-green-600' : 'text-amber-600'}>Minimum: {minWords} words</span>}</div>}
      <Button onClick={handleSave} className="bg-[#20acf6] hover:bg-[#3bb8f7]" data-testid="save-reflection-btn"><Check className="h-4 w-4 mr-2" /> {isCompleted ? 'Update Reflection' : 'Save Reflection'}</Button>
    </div>
  );
};

export default ReflectionJournalElement;
